/**
 * @generated SignedSource<<206168905afba7fd67671dcf662c4ede>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RatecardProposalProviderRatecardProposalConsultantQuery$variables = {
  id: string;
};
export type RatecardProposalProviderRatecardProposalConsultantQuery$data = {
  readonly ratecardProposal: {
    readonly announcementSetId: string | null;
    readonly hasAcceptedBids: boolean | null;
    readonly hasOpenBids: boolean | null;
    readonly id: string;
    readonly ignoreDeadlines: boolean;
    readonly internalDocumentSetId: string | null;
    readonly isCurrentUserAdmin: boolean | null;
    readonly isCurrentUserReadonly: boolean | null;
    readonly members: ReadonlyArray<{
      readonly email: string;
      readonly firstName: string;
      readonly id: string;
      readonly lastName: string;
    } | null> | null;
    readonly projectId: string | null;
    readonly projectInformation: {
      readonly onHold: boolean | null;
      readonly projectTimezone: string | null;
      readonly rates: string | null;
      readonly selectiveBids: boolean | null;
      readonly state: string | null;
      readonly supplements: string | null;
      readonly vat: string | null;
    } | null;
    readonly projectName: string | null;
    readonly questionSetId: string | null;
    readonly referenceCurrency: {
      readonly id: string;
      readonly isoCurrencyCode: string;
    } | null;
    readonly state: string;
    readonly " $fragmentSpreads": FragmentRefs<"AcceptProposalInvitationButton_ratecardProposal" | "AttachmentsForm_ratecardProposal" | "BiddingDetailsSummary_ratecardProposal" | "RatecardProposalFinancialTable_ratecardProposal" | "RatecardProposalSidebar_ratecardProposal" | "RatecardProposalStepper_ratecardProposal" | "TenderIntroductionRatecardSummary_ratecardProposal">;
  } | null;
};
export type RatecardProposalProviderRatecardProposalConsultantQuery = {
  response: RatecardProposalProviderRatecardProposalConsultantQuery$data;
  variables: RatecardProposalProviderRatecardProposalConsultantQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ignoreDeadlines",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "announcementSetId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "internalDocumentSetId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCurrentUserAdmin",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCurrentUserReadonly",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "questionSetId",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoCurrencyCode",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "CurrencyNode",
  "kind": "LinkedField",
  "name": "referenceCurrency",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectTimezone",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "selectiveBids",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rates",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supplements",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vat",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "onHold",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "UserNode",
  "kind": "LinkedField",
  "name": "members",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasOpenBids",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasAcceptedBids",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "additionalInformation",
  "storageKey": null
},
v24 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fileName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fileUrl",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RatecardProposalProviderRatecardProposalConsultantQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RatecardProposalNode",
        "kind": "LinkedField",
        "name": "ratecardProposal",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v13/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RatecardProjectInformation",
            "kind": "LinkedField",
            "name": "projectInformation",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              (v6/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/)
            ],
            "storageKey": null
          },
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RatecardProposalSidebar_ratecardProposal"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RatecardProposalStepper_ratecardProposal"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TenderIntroductionRatecardSummary_ratecardProposal"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RatecardProposalFinancialTable_ratecardProposal"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BiddingDetailsSummary_ratecardProposal"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AttachmentsForm_ratecardProposal"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AcceptProposalInvitationButton_ratecardProposal"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RatecardProposalProviderRatecardProposalConsultantQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RatecardProposalNode",
        "kind": "LinkedField",
        "name": "ratecardProposal",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v13/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RatecardProjectInformation",
            "kind": "LinkedField",
            "name": "projectInformation",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              (v6/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "proposalsOverdue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "editMode",
                "storageKey": null
              },
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "openEnd",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "validityMonths",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "volumeEstimate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CurrencyNode",
                "kind": "LinkedField",
                "name": "referenceCurrency",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isoCurrencyName",
                    "storageKey": null
                  },
                  (v12/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mandayEstimate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IndustryStandardNode",
                "kind": "LinkedField",
                "name": "industryStandard",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "industryEn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "industryDe",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "companyName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "companyWebsite",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "companyAddressLineOne",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "companyAddressLineTwo",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "companyAddressLineThree",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "companyPostalCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "companyCity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CountryNode",
                "kind": "LinkedField",
                "name": "companyCountry",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commonNameEn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commonNameDe",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RevenueRangeNode",
                "kind": "LinkedField",
                "name": "companySizeRevenue",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "revenueRange",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EmployeesRangeNode",
                "kind": "LinkedField",
                "name": "companySizeEmployees",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employeesRange",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ServiceStandardNode",
                "kind": "LinkedField",
                "name": "serviceStandard",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "serviceEn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "serviceDe",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v23/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RatecardProjectFileNodeConnection",
                "kind": "LinkedField",
                "name": "projectAttachments",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RatecardProjectFileNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RatecardProjectFileNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v24/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TimelineEventNodeConnection",
                "kind": "LinkedField",
                "name": "timelineEvents",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimelineEventNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimelineEventNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "date",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "description",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "eventType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hardLimit",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RatecardProposalValidationNode",
            "kind": "LinkedField",
            "name": "validation",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tenderIntroduction",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ratecard",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "attachments",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allSuccessful",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "errorMessage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v23/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RatecardProposalFileNodeConnection",
            "kind": "LinkedField",
            "name": "proposalAttachments",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RatecardProposalFileNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RatecardProposalFileNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v24/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "023b9586b8e3066bbdfeee2238511de6",
    "id": null,
    "metadata": {},
    "name": "RatecardProposalProviderRatecardProposalConsultantQuery",
    "operationKind": "query",
    "text": "query RatecardProposalProviderRatecardProposalConsultantQuery(\n  $id: ID!\n) {\n  ratecardProposal(id: $id) {\n    id\n    ignoreDeadlines\n    announcementSetId\n    internalDocumentSetId\n    state\n    isCurrentUserAdmin\n    isCurrentUserReadonly\n    projectName\n    projectId\n    questionSetId\n    referenceCurrency {\n      id\n      isoCurrencyCode\n    }\n    projectInformation {\n      projectTimezone\n      state\n      selectiveBids\n      rates\n      supplements\n      vat\n      onHold\n    }\n    members {\n      id\n      email\n      firstName\n      lastName\n    }\n    hasOpenBids\n    hasAcceptedBids\n    ...RatecardProposalSidebar_ratecardProposal\n    ...RatecardProposalStepper_ratecardProposal\n    ...TenderIntroductionRatecardSummary_ratecardProposal\n    ...RatecardProposalFinancialTable_ratecardProposal\n    ...BiddingDetailsSummary_ratecardProposal\n    ...AttachmentsForm_ratecardProposal\n    ...AcceptProposalInvitationButton_ratecardProposal\n  }\n}\n\nfragment AcceptProposalInvitationButton_ratecardProposal on RatecardProposalNode {\n  id\n  state\n  isCurrentUserAdmin\n  projectInformation {\n    proposalsOverdue\n  }\n}\n\nfragment AttachmentsForm_ratecardProposal on RatecardProposalNode {\n  id\n  state\n  projectId\n  additionalInformation\n  projectInformation {\n    proposalsOverdue\n  }\n  proposalAttachments {\n    edges {\n      node {\n        id\n        fileName\n        fileUrl\n      }\n    }\n  }\n}\n\nfragment BiddingDetailsSummary_ratecardProposal on RatecardProposalNode {\n  id\n  state\n  projectInformation {\n    projectTimezone\n    state\n    selectiveBids\n    rates\n    supplements\n    vat\n    referenceCurrency {\n      id\n      isoCurrencyCode\n    }\n  }\n}\n\nfragment RatecardProposalFinancialTable_ratecardProposal on RatecardProposalNode {\n  id\n  state\n  projectInformation {\n    projectTimezone\n    proposalsOverdue\n    selectiveBids\n  }\n}\n\nfragment RatecardProposalSidebar_ratecardProposal on RatecardProposalNode {\n  id\n  projectId\n  projectName\n  state\n  projectInformation {\n    projectTimezone\n    state\n    selectiveBids\n    rates\n    supplements\n    vat\n    onHold\n  }\n  validation {\n    tenderIntroduction\n    ratecard\n    attachments\n    allSuccessful\n    errorMessage\n  }\n}\n\nfragment RatecardProposalStepper_ratecardProposal on RatecardProposalNode {\n  id\n  projectId\n  projectName\n  validation {\n    tenderIntroduction\n    ratecard\n    attachments\n    allSuccessful\n    errorMessage\n  }\n}\n\nfragment TenderIntroductionRatecardSummary_ratecardProposal on RatecardProposalNode {\n  id\n  announcementSetId\n  state\n  isCurrentUserAdmin\n  projectName\n  projectId\n  referenceCurrency {\n    id\n    isoCurrencyCode\n  }\n  projectInformation {\n    proposalsOverdue\n    editMode\n    projectName\n    projectTimezone\n    startDate\n    openEnd\n    validityMonths\n    volumeEstimate\n    referenceCurrency {\n      isoCurrencyName\n      isoCurrencyCode\n      id\n    }\n    mandayEstimate\n    industryStandard {\n      industryEn\n      industryDe\n      id\n    }\n    companyName\n    companyWebsite\n    companyAddressLineOne\n    companyAddressLineTwo\n    companyAddressLineThree\n    companyPostalCode\n    companyCity\n    companyCountry {\n      commonNameEn\n      commonNameDe\n      id\n    }\n    companySizeRevenue {\n      revenueRange\n      id\n    }\n    companySizeEmployees {\n      employeesRange\n      id\n    }\n    serviceStandard {\n      serviceEn\n      serviceDe\n      id\n    }\n    additionalInformation\n    projectAttachments {\n      edges {\n        node {\n          id\n          fileName\n          fileUrl\n        }\n      }\n    }\n    timelineEvents {\n      edges {\n        node {\n          id\n          name\n          date\n          description\n          eventType\n          hardLimit\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7d3467df603c73cb9e150e1c930bbff5";

export default node;
